module.exports = __webpack_public_path__ + "static/img/4areaB_7.9f0fc9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character2/4areaB_7.png
// module id = 1187
// module chunks = 1